import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import TextInputField from '../../infra/components/formInput/CustomTextInput' 
import ActionAdd from '../../store/action/RepliesCloseTicket/Add'
import ActionEdit from '../../store/action/RepliesCloseTicket/Edit'
import {IsEdit, IsCreate, IsView } from '../../store/constants'
import ComboboxInput from "../../infra/components/formInput/ComboboxInput";
import ActionGetAllClient from "../../store/action/Client/FetchAll";
import ActionGetAllDivision from "../../store/action/Division/FetchAll";
import ActionGetAllSender from "../../store/action/Sender/FetchAll";

class Form extends Component{

  constructor(props){
    super(props);
    this.state ={
      form : fromJS({
        // 'category-id':'',
        // 'category-name' : '',
          'id':'',
          "client-id-form": '',
          "division-id-form": '',
          "sender-id-form" : '',
          "repliesCloseTicket-id":'',
          "type":'',
          "message":'',
          "url":'',
      }),
      loadded: false,
      disabled: false,
      errors: fromJS({}),
      error: '',
        disabledHead:false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    //baru
      this.handleChangeForm = this.handleChangeForm.bind(this);
  }

  handleChange(field, value) {
    var formVal = this.state.form;
    formVal = formVal.set(field,value); 
    this.setState({ form:formVal })
  }

    handleChangeForm(field, value, label) {
        var formVal = this.state.form;
        if(field === 'client-id-form'){
            this.setState({client_id: value});
            this.props.actionGetAllSender(value);
            this.props.actionGetAllDivision(value);

            if(value === '' || value === undefined || value===null){
                formVal = formVal.set(field,value).set('sender-id-form','').set('division-id-form','')
            }else{
                formVal = formVal.set(field,value)
            }
        }else if (field === 'division-id-form'){
            this.props.actionGetAllSender(this.state.client_id, value);
            /*if(value === '' || value === undefined || value===null){
                formVal = formVal.set(field,value).set('sender-id-form','')
            }else{
                formVal = formVal.set(field,value)
                this.props.actionGetAllSender(this.state.client_id, value);
            }*/

        }else{
            formVal = formVal.set(field,value)
        }
        /*
        if (field === 'division-id-form') {
            this.props.actionGetAllSender(this.state.client_id, value);
        }
        */
        this.setState({ form:formVal })
    }

  async handleSubmit(dispatch) {

    const form = this.state.form;
    if(form.get('message') === '' || form.get('message') === undefined){
        this.setState({error : "message name cannot be empty!"});
        toast.error('message cannot be empty!', toast.POSITION.TOP_RIGHT);
    }else if(form.get('sender-id-form') === '' || form.get('sender-id-form') === undefined){
        this.setState({error : "sender cannot be empty!"});
        toast.error('sender cannot be empty!', toast.POSITION.TOP_RIGHT);
    }else{
      switch(this.props.actionType) {
        case IsCreate:
            await this.SubmitNewData();
          break;
        case IsEdit:
            await this.SubmitEditData();
          break;
        default:
          // code block
      }  

    }
  }

  async SubmitNewData(){
    const form = this.state.form;
    var data =  
        {'data' : 
            {
                // 'category-name': form.get('category-name'),
                'senderid': form.get('sender-id-form'),
                'type': form.get('type'),
                'message': form.get('message'),
                'url':form.get('url'),
                'status':1
            }
        };
    var response = await this.props.actionAdd(data);
    if(response.ok){
      toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
      this.props.handleCancelForm(true);
    }else{
      //toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
    }
  }

  async SubmitEditData(){
    const form = this.state.form;
    var data = 
        {
          'data' : {
                // 'category-id': form.get('category-id'),
                // 'category-name': form.get('category-name'),
              'id':form.get('id'),
              'senderid': form.get('sender-id-form'),
              'type': form.get('type'),
              'message': form.get('message'),
              'url':form.get('url'),
              'status':1
            }
        };
    //debugger
        var response = await this.props.actionEdit(data);
        if(response.ok){
          toast.success('Edit Success!', toast.POSITION.TOP_RIGHT);
          this.props.handleCancelForm(true); 
        }else{
          //toast.error('Edit Failed', toast.POSITION.TOP_RIGHT);
        }
  }

  handleCancel(){
    this.props.handleCancelForm(false);  
  }

  componentWillMount(){
    if(this.props.item != null || this.props.item !== undefined){
      if((this.props.actionType === IsView || this.props.actionType === IsEdit) && !this.state.loadded){
          this.props.actionGetAllSender(this.props.item.get('client-id'));
        this.setState({
          form:  fromJS({
            'id':   this.props.item.get('id'),
            'client-id-form':this.props.item.get('client-id'),
            'sender-id-form' : this.props.item.get('senderid'),
            'type': this.props.item.get('type'),
            'message': this.props.item.get('message'),
            'url':this.props.item.get('url'),
          }),
          loadded: true,
          disabled: (this.props.actionType === IsView),
          disabledHead : true
        })  
      }
    }
  }

  render(){
    const { form, errors, disabled, disabledHead } = this.state;
    return (
      <div className="card no-margin-bottom">
        <div className="body">

            <div className="row no-margin-bottom">
                <span className="col-sm-2">Client</span>
                <div className="col-sm-10">
                    <ComboboxInput
                        field='client-id-form'
                        value={form.get('client-id-form')}
                        options={fromJS({
                            'source': this.props.clientall,
                            'value': 'client-id',
                            'label': 'client-name'
                        }) }
                        onChange={(field, value, label) => this.handleChangeForm(field,value,label)}
                        disabled={ disabledHead }
                        placeholder="Client"
                    />
                </div>
            </div>
            <div className="row no-margin-bottom">
                <span className="col-sm-2">Sender</span>
                <div className="col-sm-10">
                    <ComboboxInput
                        field='sender-id-form'
                        value={form.get('sender-id-form')}
                        options={fromJS({
                            'source': this.props.senderall,
                            'value': 'sender-id',
                            'label': 'sender-name'
                        }) }
                        onChange={(field, value, label) => this.handleChangeForm(field,value,label)}
                        placeholder="Sender"
                        // disabled={this.state.disabled}
                        disabled={ disabledHead }
                        hasError={errors.has('sender-id-form')}
                    />
                </div>
            </div>
            <div className="row no-margin-bottom">
                <span className="col-sm-2">Type</span>
                <div className="col-sm-10">
                  {/*<TextInputField className="form-control"*/}
                  {/*    field={'type'}*/}
                  {/*    value={ form.get('type')}*/}
                  {/*    onChange={(field, value) => this.handleChange(field,value)}*/}
                  {/*    placeholder="type"*/}
                  {/*    disabled={ disabled }*/}
                  {/*    hasError={errors.has('type')}*/}
                  {/*/>*/}
                    <ComboboxInput
                        field='type'
                        value={form.get('type')}
                        options={fromJS({
                            'source': [{'labels':'text','values':'text'},{'labels':'media','values':'media'}],
                            'value': 'values',
                            'label': 'labels'
                        }) }
                        onChange={(field, value, label) => this.handleChange(field,value)}
                        placeholder="Sender"
                        // disabled={this.state.disabled}
                        disabled={ disabled }
                        hasError={errors.has('sender-id-form')}
                    />

                </div>
            </div>
            <div className="row no-margin-bottom">
                <span className="col-sm-2">Message</span>
                <div className="col-sm-10">
                  <TextInputField className="form-control"
                      field={'message'}
                      value={ form.get('message')}
                      onChange={(field, value) => this.handleChange(field,value)}
                      placeholder="message"
                      disabled={ disabled }
                      hasError={errors.has('message')}
                  />
                </div>
            </div>
            <div className="row no-margin-bottom">
                <span className="col-sm-2">Url</span>
                <div className="col-sm-10">
                  <TextInputField className="form-control"
                      field={'url'}
                      value={ form.get('url')}
                      onChange={(field, value) => this.handleChange(field,value)}
                      placeholder="url"
                      disabled={ disabled }
                      hasError={errors.has('url')}
                  />
                </div>
          </div>

          <div className="row no-margin-bottom">
            <span className="col-sm-2"></span>
            <div className="col-sm-10">
            <button type="button"
                  className="btn btn-wide btn-danger"
                  value="Cancel"
                  onClick={ this.handleCancel }>
                    Cancel
              </button>
              <button type="button"
                  className="btn btn-wide btn-success"
                  onClick={ this.handleSubmit }>
                    Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default connect(
  (state) => {
      return {
          Users: state.user.users,
      //    baru
          clientall: state.user.clientall,
          divisionall: state.user.divisionall,
          senderall: state.user.senders,
      }
  },
  dispatch => bindActionCreators({
      actionAdd: ActionAdd,
      actionEdit: ActionEdit,
      //baru
      actionGetAllClient:ActionGetAllClient,
      actionGetAllDivision: ActionGetAllDivision,
      actionGetAllSender: ActionGetAllSender,
  }, dispatch),
)(Form);